import getIssue from './getIssue'

function getCountIssueByStatus(status) {
    return Object.keys(getIssue).filter((key, index) => {
        return getIssue[key].data.getIssue.status == status
    }).length
}
export default {
    data: {
        getProject: {
            issue_count: {
                total: Object.keys(getIssue).length,
                open: getCountIssueByStatus('open'),
                closed: getCountIssueByStatus('closed'),
                in_review: getCountIssueByStatus('in_review'),
            },
            issue_filter_results: {
                total: Object.keys(getIssue).length,
                open: getCountIssueByStatus('open'),
                closed: getCountIssueByStatus('closed'),
                in_review: getCountIssueByStatus('in_review'),
            },
            issues: Object.keys(getIssue).map(key => getIssue[key].data.getIssue),
        },
    },
}
